import { render, staticRenderFns } from "./DashboardStoryVersions.vue?vue&type=template&id=76a9ecbf&"
import script from "./DashboardStoryVersions.vue?vue&type=script&lang=js&"
export * from "./DashboardStoryVersions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports